import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { UnsubscriptionIndexComponent } from './unsubscription-index';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('unsubscription.unsubscription-index', {
            url: '/unsubscription-index',
            data: {
                authorisationLevel: 1,
                pageTitle: 'Disiscrizione'
            },
            resolve: {
                user: ($q, $rootScope, store: ng.a0.storage.IStoreService, UserService) => {
                    let email = $rootScope.currentUser().sub === undefined ? store.get('user').accountData.email : $rootScope.currentUser().sub;
                    return UserService.getUser(email)
                        .then((result) => {
                            return result.data;
                        }, (error) => {
                            return $q.reject(error);
                        });
                }
            },
            'views': {
                'multiContentUnsubscription': {
                    template: '<unsubscription-index flex="100"></unsubscription-index>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const UnsubscriptionIndexModule: string = ng
    .module('unsubscription-index', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('unsubscriptionIndex', UnsubscriptionIndexComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/sections/unsubscription/unsubscription-index/unsubscription-index.module.ts